import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { class: "home-echarts-header__controls" }

import type { PropType, Ref } from 'vue'
import { onBeforeMount, reactive, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import dayjs, { Dayjs } from 'dayjs'
import { getNewActivatedCustomerMonthlyRevenue } from '@/api/gucangSales/dataBoard'


const __default__ = {
  name: 'NewActivatedCustomerMonthlyRevenue'
}

interface QueryFormType {
  employeeNo?: string
  dataPermissionQueryType: number
  startDay?: string
  endDay?: string
}

interface ItemCommonType {
  monthValue?: number,
  salesAmount?: number, // 新激活客户每月销售额(元)
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '新激活客户每月销售额（元）'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  employeeNo: {
    type: String as PropType<string>
  }
},
  setup(__props) {

const yearValue = ref<Dayjs>(dayjs())
const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const startMonth = ref<string>(dayjs(yearValue.value).startOf('month').format('YYYY01'))
const endMonth = ref<string>(dayjs(yearValue.value).endOf('month').format('YYYY12'))
const xAxisData = ref<any[]>([])
const queryForm = reactive<QueryFormType>({
  startDay: dayjs(yearValue.value).startOf('year').format('YYYY/MM/DD'),
  endDay: dayjs(yearValue.value).endOf('year').format('YYYY/MM/DD'),
  dataPermissionQueryType: props.employeeNo ? 2 : 1,
  employeeNo: props.employeeNo
})
watch(() => props.employeeNo, (val) => {
  queryForm.employeeNo = val
  if (val) {
    queryForm.dataPermissionQueryType = 2
  } else {
    queryForm.dataPermissionQueryType = 1
  }
  getData()
})
const handleDateChange = () => {
  queryForm.startDay = dayjs(yearValue.value).startOf('year').format('YYYY/MM/DD')
  queryForm.endDay = dayjs(yearValue.value).endOf('year').format('YYYY/MM/DD')
  startMonth.value = dayjs(yearValue.value).startOf('month').format('YYYY01')
  endMonth.value = dayjs(yearValue.value).endOf('month').format('YYYY12')
  xAxisData.value = generateTimeArray(startMonth.value, endMonth.value, 'YYYYmm')
  getData()
}

function generateTimeArray(startTime: string, endTime: string, format: 'YYYYmm' | 'YYYYww' | 'YYYY/MM/DD') {
  const start = dayjs(startTime, format)
  const end = dayjs(endTime, format)
  const result = []

  let current = start

  if (format === 'YYYYmm') {
    while (current.isBefore(end) || current.isSame(end)) {
      result.push({
        value: current.format(format),
        name: current.format('m') + '月'
      })
      current = current.add(1, 'm')
    }
  } else if (format === 'YYYY/MM/DD') {
    while (current.isBefore(end) || current.isSame(end)) {
      result.push({
        value: current.format(format),
        name: current.format('D')
      })
      current = current.add(1, 'day')
    }
  } else {
    throw new Error('Unsupported format')
  }
  return result
}

const getData = () => {
  spinning.value = true
  getNewActivatedCustomerMonthlyRevenue(queryForm).then((res) => {
    const salesAmountList = res.data?.salesAmountList as unknown as ItemCommonType[]
    const activatedCustomerMonthlyRevenueList = transChartData(salesAmountList)
    if (activatedCustomerMonthlyRevenueList.length) {
      showECharts.value = true
      initChart(activatedCustomerMonthlyRevenueList)
    } else {
      showECharts.value = false
      initChart([])
    }
  }).finally(() => {
    spinning.value = false
  })
}
/// 格式化接口数据和日期对应
const transChartData = (serviceData: ItemCommonType[]) => {
  const matchData: number[] = []
  if (serviceData && serviceData.length > 0) {
    xAxisData.value.forEach((axis) => {
      const matchItem = serviceData.find((item) => {
        return (item.monthValue ?? 0).toString() === axis.value
      })
      if (matchItem) {
        matchData.push(matchItem.salesAmount ?? 0)
      } else {
        matchData.push(0)
      }
    })
  }
  return matchData
}
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
const initChart = (activatedCustomerMonthlyRevenueList: number[]) => {
  setOptions({
    // 悬浮窗
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: 'White'
      },
      formatter: function (params) {
        const currentData = xAxisData.value[params[0].dataIndex].value
        const toolsTipsResult = []
        toolsTipsResult.push(currentData)
        for (let i = 0; i < params.length; i++) {
          const currentParam = params[i]
          toolsTipsResult.push(currentParam.seriesName + '  <strong>' + (i === 2 ? currentParam.value + '%' : currentParam.value) + '</strong>')
          // toolsTipsResult.push('目标值  <strong>' + currentHoverData?.quantity + '</strong>')
          // toolsTipsResult.push('完成值  <strong>' + currentHoverData?.total + '</strong>')
          // toolsTipsResult.push(`完成率  <strong>${(currentHoverData?.total ? Number((((currentHoverData.quantity ?? 0) / currentHoverData.total) * 100).toFixed(2)) : 0)}%` + '</strong>')
        }
        return toolsTipsResult.join('<br>')
      }
    },
    /// 在这里配置线条颜色和legend颜色一致
    color: '#FF9A3E',
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData.value.map((item) => item.name)
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: '#D8DFE4',
          type: 'dashed'
        }
      }
    },
    series: [
      {
        name: '销售额',
        type: 'line',
        smooth: true,
        data: activatedCustomerMonthlyRevenueList
      }
    ]
  })
}
onBeforeMount(() => {
  if (!queryForm.startDay) {
    queryForm.startDay = dayjs(yearValue.value).startOf('year').format('YYYY/MM/DD')
  }
  if (!queryForm.endDay) {
    queryForm.endDay = dayjs(yearValue.value).endOf('year').format('YYYY/MM/DD')
  }
  xAxisData.value = generateTimeArray(startMonth.value, endMonth.value, 'YYYYmm')
  getData()
})

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_date_picker, {
          onChange: handleDateChange,
          value: yearValue.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((yearValue).value = $event)),
          allowClear: false,
          picker: "year"
        }, null, 8, ["value"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})